<template>
  <div>
    <label v-if="label" class="form-label" :for="id">{{ label }}</label>
    <input
      :id="id"
      ref="fileInput"
      type="file"
      multiple
      class="hidden"
      :accept="accept"
      @change="change"
    />
    <div class="mt-1 flex items-center">
      <button
        type="button"
        class="form-input flex flex-1 items-center"
        @click="$refs.fileInput.click()"
      >
        <span class="flex-1 min-h-[24px] flex items-center text-gray-500">
          {{ items.length ? 'Добавить ещё фото' : 'Browse' }}
        </span>
      </button>
    </div>
    <div v-if="items.length" class="mt-3 flex flex-wrap gap-3">
      <div
        v-for="(item, index) in items"
        :key="item.key"
        class="group relative h-20 w-20 shrink-0 overflow-hidden rounded-lg bg-gray-100"
      >
        <img
          :src="item.thumbnail"
          class="h-full w-full cursor-pointer object-cover"
          alt="Order photo"
          @click="$emit('preview', item.full)"
        />
        <button
          type="button"
          class="absolute right-1 top-1 flex h-5 w-5 items-center justify-center rounded-full bg-black text-xs text-white opacity-70 hover:opacity-100"
          title="Удалить"
          @click.stop="remove(index)"
        >
          &times;
        </button>
      </div>
    </div>
    <div v-if="errors?.length" class="form-error">{{ errors[0] }}</div>
  </div>
</template>

<script>
export default {
  props: {
    modelValue: {
      type: Array,
      default: () => [],
    },
    errors: {
      type: Array,
      default: () => [],
    },
    id: {
      type: String,
      default: () => Math.random().toString(36).substring(2, 9),
    },
    accept: {
      type: String,
      default: null,
    },
    label: {
      type: String,
      default: null,
    },
  },
  emits: ['update:modelValue', 'preview'],
  computed: {
    items() {
      return this.modelValue.map((photo) => {
        if (photo instanceof File) {
          const url = URL.createObjectURL(photo);
          return { key: url, thumbnail: url, full: url };
        }
        return { key: photo.id, thumbnail: photo.thumbnail, full: photo.full };
      });
    },
  },
  methods: {
    change(event) {
      const files = Array.from(event.target.files || []);
      if (files.length) {
        this.$emit('update:modelValue', [...this.modelValue, ...files]);
      }
      if (this.$refs.fileInput) {
        this.$refs.fileInput.value = '';
      }
    },
    remove(index) {
      const updated = [...this.modelValue];
      updated.splice(index, 1);
      this.$emit('update:modelValue', updated);
    },
  },
};
</script>
